module.exports = __webpack_public_path__ + "img/slack-logo.ed6c324b.png";